import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "../Hooks/useApi";
import { statusCode200 } from "../helpers";
import Loader from "../components/Loader";
export default function WalletGuard({ children }) {

    const api = useApi()
    const [loading, setLoading] = useState(true);
    const [walletExists, setWalletExists] = useState(false);
    const navigate = useNavigate();
    const checkWalletEnabled = async () => {
        setLoading(true);
        const response = await api?.checkWalletEnableApi({ "isWalletEnabled": true });
        if (statusCode200(response)) {
            console.log("Response check wallet enable", response);
            setWalletExists(response?.data?.body?.isWalletEnabled);
        } else {
            toast.error(response?.data?.headers?.msg)
        }
        setLoading(false)
    }

    useEffect(() => {

        checkWalletEnabled();
    }, []);

    if (loading) return <Loader />;

    return walletExists ? children : null;
}
